import wx from 'weixin-js-sdk'
import { WEIXIN_BASE } from './base'
import { WEIXIN_PAY } from './pay'
import * as config from '../../modules/data/config'
import { UTILS } from '../utils'

//需在用户可能点击分享按钮前就先调用
var WEIXIN = {
    /**
     * 获取微信扫码登录地址wxb92e4353fb2d7f1e
     */
	getWechatAuthUrl() {
        var wechatBathUrl = 'http://wx.wisdomww.com/index',
            wechatAuthUrl = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx032f7e2655bcb63f';
        wechatAuthUrl = wechatAuthUrl + '&redirect_uri=' + window.encodeURIComponent(wechatBathUrl);
        wechatAuthUrl = wechatAuthUrl + '&response_type=code&scope=snsapi_login&state=web#wechat_redirect';
        console.log('wechatAuthUrl---', wechatAuthUrl)
        return wechatAuthUrl;
    },
    /**
     * 微信分享配置
     */
    initConfigShare(sucFunc, failFunc) {
        var userPageData = AppFate.$store.state.user.userPageData;
        WEIXIN_BASE.getAuthorationAndConfigJsSDK(function(){
            console.log('initConfigShare------', userPageData)
            // 处理分享参数
            var newTitle = '2023年你的卯力值已准备好，速来看。',
                newDesc = '欲知前兔如何，看我卯力有多足!',
                // imgUrl = config.CONFIG_CDN_URL + 'images_rabbit/share/share-img-'+(userPageData.titleClass ? userPageData.titleClass : 'default')+'.png',
                imgUrl = config.CONFIG_CDN_URL + 'images_rabbit/share/share-img-default.png',
                linkUrl = 'http://'+window.location.host;
            
            newTitle = userPageData && userPageData.cowName ? UTILS.getShareArrByData(userPageData) : newTitle;
            var WxShareData = {
                title: newTitle,
                desc: newDesc,
                linkurl: linkUrl,
                img: imgUrl
            }
            console.log("getWeixinSdkConfig----配置成功", WxShareData);

            // 页面加载完成后用户就有可能调用微信的分享，所以当页面ready 完后就加载
            wx.ready(function () {
                var commonShareData = {
                    // 分享标题
                    title: WxShareData.title,
                    // 分享描述
                    desc: WxShareData.desc,
                    // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    link: WxShareData.linkurl,
                    // 分享图标
                    imgUrl: WxShareData.img,
                    success: function () {
                        console.log('分享回调函数');
                        // alert('22222---分享成功回调')
                        // alert(WxShareData.linkurl);
                        if(sucFunc && typeof(sucFunc) == 'function'){
                            sucFunc();
                        }
                    },
                }
                wx.onMenuShareTimeline(commonShareData);//1.0
                wx.updateTimelineShareData(commonShareData);//1.0
                wx.onMenuShareAppMessage(commonShareData)//1.4
                wx.updateAppMessageShareData(commonShareData)//1.4
            });

            // 微信预加载失败回调
            wx.error(function (res) {
                console.log(res);
                if(failFunc && typeof(failFunc) == 'function'){
                    failFunc();
                }
            });
        });
    }
}

export {
    WEIXIN, WEIXIN_PAY
}

